import React from 'react';
interface HeartLoaderProps {
  size?: number;
}

const HeartLoader: React.FC<HeartLoaderProps> = ({ size = 50 }) => {
  return (
    <>
      <div
        className="beating-heart"
        role="img"
        aria-label="Chargement en cours"
      >
        <div className="heart"></div>
        <div className="heart heart2"></div>
        <div className="heart heart3"></div>
        <div className="heart heart4"></div>
        <div className="heart heart5"></div>
      </div>

      <style jsx>{`
        .beating-heart {
          width: ${size}px;
          margin: ${size}px auto;
          height: ${size}px;
        }

        .beating-heart .heart {
          position: absolute;
          width: ${size}px;
          height: ${size * 0.9}px;
          opacity: 0.6;
          animation: beat 3s infinite ease-in-out;
        }

        .heart:before,
        .heart:after {
          position: absolute;
          content: '';
          left: ${size * 0.5}px;
          top: 0;
          width: ${size * 0.5}px;
          height: ${size * 0.8}px;
          background: var(--clr-secondary-1);
          border-radius: ${size}px ${size}px 0 0;
          transform: rotate(-45deg);
          transform-origin: 0 100%;
        }

        .heart:after {
          left: 0;
          transform: rotate(45deg);
          transform-origin: 100% 100%;
        }

        .beating-heart .heart2 {
          animation-delay: -1s;
        }

        .beating-heart .heart3 {
          animation-delay: -1.5s;
        }

        .beating-heart .heart4 {
          animation-delay: -2s;
        }

        .beating-heart .heart5 {
          animation-delay: -2.5s;
        }

        @keyframes beat {
          0%,
          100% {
            -webkit-transform: scale(0);
          }
          50% {
            -webkit-transform: scale(1);
          }
        }
      `}</style>
    </>
  );
};

export default HeartLoader;
